<template>
  <div class="ppv-filter-group">
    <div class="ppv-filter-label-row">
      <div class="ppv-filter-label">
        {{ $t("ppv.filters.disease_category") }}
        <span v-if="selectedDiseases.length > 0" class="ppv-label-count">
          {{ $t("ppv.filters.selected_count", { n: selectedDiseases.length }) }}
        </span>
      </div>
    </div>

    <div class="ppv-chips-row">
      <PpvChip
        v-for="cat in activeDiseaseCategories"
        :key="cat.name"
        variant="disease"
        :selected="isSelected(cat.name)"
        :icon="isSelected(cat.name) ? icons.mdiCheck : ''"
        @click="onToggle(cat.name)"
      >
        {{ diseaseCategoryToken(cat.name) ? $t(diseaseCategoryToken(cat.name)) : cat.name }}
        <span class="ppv-chip-count-blue">{{ cat.count }}</span>
      </PpvChip>

      <PpvChip
        v-if="inactiveDiseaseCategories.length > 0"
        variant="more"
        @click="diseaseCatOpen = !diseaseCatOpen"
      >
        {{ $t("ppv.filters.more", { n: inactiveDiseaseCategories.length }) }}
        <v-icon>{{ diseaseCatOpen ? icons.mdiChevronUp : icons.mdiChevronDown }}</v-icon>
      </PpvChip>
    </div>

    <div v-if="diseaseCatOpen && inactiveDiseaseCategories.length > 0" class="ppv-disease-expanded">
      <div class="ppv-chips-row">
        <PpvChip
          v-for="cat in inactiveDiseaseCategories"
          :key="cat.name"
          :disabled="true"
          @click="onToggle(cat.name)"
        >
          {{ diseaseCategoryToken(cat.name) ? $t(diseaseCategoryToken(cat.name)) : cat.name }} ({{ cat.count }})
        </PpvChip>
      </div>
    </div>
  </div>
</template>

<script>
import icons from '@/mixins/icons'
import { diseaseCategoryToken } from '@/mixins/clinicalTranslations'
import PpvChip from '../shared/PpvChip.vue'

export default {
  name: 'PpvDiseaseFilter',
  components: { PpvChip },
  mixins: [icons],
  props: {
    selectedDiseases: { type: Array, default: () => [] },
    activeDiseaseCategories: { type: Array, required: true },
    inactiveDiseaseCategories: { type: Array, required: true },
    onToggle: { type: Function, required: true },
  },
  data() {
    return {
      diseaseCatOpen: false,
    }
  },
  methods: {
    isSelected(name) {
      return this.selectedDiseases.includes(name)
    },
    diseaseCategoryToken,
  },
}
</script>

<style scoped>
.ppv-filter-group {
  margin-bottom: 20px;
}
.ppv-filter-label {
  font-size: 11px;
  font-weight: 700;
  color: #8a96a8;
  letter-spacing: 0.08em;
  margin-bottom: 12px;
  text-transform: uppercase;
}
.ppv-filter-label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ppv-label-count {
  color: #5850ec;
  font-weight: 500;
  font-size: 12px;
  margin-left: 6px;
}
.ppv-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.ppv-chip-count-blue {
  background: #eef7f9;
  border-radius: 20px;
  padding: 1px 7px;
  font-size: 11px;
  margin-left: 6px;
  color: #4b91ac;
  font-weight: 700;
}
.ppv-disease-expanded {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #eaedf2;
}
</style>
